import React, { CSSProperties, ReactElement } from 'react';
import { copy } from '@/common/utils';
import classnames from 'classnames';
import { message, Tooltip } from 'antd';
import DefaultIcon from './icon';
import './index.less';

const Copy: React.FC<{
  text: string | undefined;
  className?: string;
  children?: ReactElement;
  icon?: ReactElement;
  size?: string;
  iconStyle?: CSSProperties;
  clickChildCanCopy?: boolean;
}> = function ({
  text,
  children,
  className,
  size = 'middle',
  iconStyle,
  icon = <DefaultIcon size={size} />,
  clickChildCanCopy = false,
  // <img
  //   className={`TY_copy-icon ${size}`}
  //   src="//img30.360buyimg.com/pop/jfs/t1/162932/19/21369/206/62412084E8e3aecd8/a4e2175dc3daae0d.png"
  //   style={iconStyle}
  // />
  // ),
}) {
  if (!text && !children) return null;

  const copyedContent = text && children ? text : text || children;

  const copyedChildren = text && children ? children : text || children;

  if (typeof copyedChildren !== 'string' && !text) return children || null;

  const classNames = classnames({
    className,
    [`TY_copy-text ${size}`]: true,
  });

  function handlerCopy(ev: React.MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    if (!copyedContent) return;
    try {
      copy(copyedContent as string);
      message.success('复制成功');
    } catch (ex) {
      console.error('复制失败', ex);
      message.error('复制失败');
    }
  }

  return (
    <span className={classNames}>
      {clickChildCanCopy ? (
        <>
          <Tooltip title="点我复制">
            <span onClick={handlerCopy} className={classNames}>
              <>{copyedChildren}</>
              {icon && (
                <span className={`TY_copy-icon ${size}`} style={iconStyle}>
                  {icon}
                </span>
              )}
            </span>
          </Tooltip>
        </>
      ) : (
        <>
          <>{copyedChildren}</>
          <Tooltip title="点我复制">
            <span onClick={handlerCopy} className={`TY_copy-icon ${size}`} style={iconStyle}>
              {icon}
            </span>
          </Tooltip>
        </>
      )}
    </span>
  );
};

export default Copy;
